<template>
  <div id="apg" style="overflow: hidden">
    <!-- navbar -->
    <header class="navbar navbar-inverse">
      <el-row :gutter="10">
        <el-col :span="12" style="margin-botomm:10px">
          <div class="navbar-header" style="height:5vh;display: flex;align-items: center;width: 100%;">
            <img src="../../assets/logo/logo.png" style="height:100%;">
            <span class="logo_title"> MPT Tianjin 2024 Year Dashboard</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div style="text-align:right">
              <el-button  circle icon="el-icon-back"></el-button>
              <el-button  circle icon="el-icon-right"></el-button>
              <el-button  circle @click="openScreenForm" icon="el-icon-search"></el-button>
              <el-button  circle @click="page" icon="el-icon-setting"></el-button>
          </div>
          <a-button type="primary">
            <template #icon>
              <icon-settings />
            </template>
          </a-button>
          <li>
            <a-tooltip>
              <a-button class="nav-btn" type="outline" :shape="'circle'" @click="handleToggleTheme">
                <template #icon>
                  <icon-moon-fill v-if="theme === 'dark'" />
                  <icon-sun-fill v-else />
                </template>
              </a-button>
            </a-tooltip>
          </li>
        </el-col>
      </el-row>
    </header>

    <div class="head">
      <!--宫格数量 24-->
      <el-row :gutter="10">
        <!--xs<768px 占用宫格数6,当xl>1929 占用的宫格数 -->
        <el-col :xs="12" :sm="8" :lg="6" :xl="4" class="elCol">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>FTT KPI</span>
            </div>
            <div>
              <dept-attend-rate :id="1" :beans="opt1"></dept-attend-rate>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="6" :xl="4" class="elCol">
          <el-card class="box-card" style="border:5px solid green;">
            <div slot="header" class="clearfix">
              <span>OEE KPI</span>
            </div>
            <div>
              <dept-attend-rate :id="2" :beans="opt2"></dept-attend-rate>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="6" :xl="4" class="elCol">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>LPA KPI</span>
            </div>
            <div>
              <dept-attend-rate :id="3" :beans="opt3"></dept-attend-rate>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="6" :xl="4" class="elCol">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>Fast KPI</span>
            </div>
            <div>
              <dept-attend-rate :id="4" :beans="opt4"></dept-attend-rate>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="6" :xl="4" class="elCol">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>Direct Labor Efficiency</span>
            </div>
            <div>
              <dept-attend-rate :id="5"></dept-attend-rate>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="6" :xl="4" class="elCol">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>Engineering Cost Savings</span>
            </div>
            <div>
              <dept-attend-rate :id="6" :beans="opt3"></dept-attend-rate>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="6" :xl="4" class="elCol">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>Inventory Turns</span>
            </div>
            <div>
              <dept-attend-rate :id="7"></dept-attend-rate>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="6" :xl="4" class="elCol">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>Cost of Quality</span>
            </div>
            <div>
              <dept-attend-rate :id="8"></dept-attend-rate>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="6" :xl="4" class="elCol">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>Supplier Defects</span>
            </div>
            <div>
              <dept-attend-rate :id="9"></dept-attend-rate>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="6" :xl="4" class="elCol">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>Health and Safety Score</span>
            </div>
            <div>
              <dept-attend-rate :id="10"></dept-attend-rate>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-dialog title="设置" width="380px" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="80px">
        <el-form-item label="每页显示">
          <el-input v-model="ruleForm.pageSize">
            <template slot="append">条</template>
          </el-input>
        </el-form-item>
        <el-form-item label="数据切换">
          <el-input v-model="ruleForm.too">
            <template slot="append">秒</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setUp('ruleForm')">确认</el-button>
          <el-button @click="defaultUp()">默认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--查询条件-->
    <el-dialog title="条件筛选" width="380px" :close-on-click-modal="false" :visible.sync="screenFormVisible">
      <el-form :model="screenForm" status-icon ref="screenForm" label-width="80px">
        <el-form-item label="选择年份">
          <el-input v-model="screenForm.pageSize">
            <template slot="append">条</template>
          </el-input>
        </el-form-item>
        <el-form-item label="选择部门">
          <el-input v-model="screenForm.too">
            <template slot="append">秒</template>
          </el-input>
        </el-form-item>
        <el-form-item label="按需显示">
          <el-input v-model="screenForm.too">
            <template slot="append">秒</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setUp('screenForm')">确认</el-button>
          <el-button @click="defaultUp()">默认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template> 

<script>
import deptAttendRate from "./component/dept-attend-rate";
export default {
  name: "App",
  components: {
    deptAttendRate,
  },
  data() {
    return {
      dialogFormVisible: false,
      screenFormVisible: false,
      ruleForm: {
        pageSize: 40,
        too: 10
      },
      screenForm: {
        pageSize: 40,
        too: 10
      },
      opt1: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'Precipitation',
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              formatter: '{value} ml'
            }
          },
          {
            type: 'value',
            name: 'Temperature',
            min: 0,
            max: 25,
            interval: 5,
            axisLabel: {
              formatter: '{value} °C'
            }
          }
        ],
        series: [
          {
            name: 'Evaporation',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' ml';
              }
            },
            data: [
              2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
            ]
          },
          {
            name: 'Precipitation',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' ml';
              }
            },
            data: [
              2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
            ]
          },
          {
            name: 'Temperature',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' °C';
              }
            },
            data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
          }
        ]
      },
      opt2: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        series: [
          {
            name: 'Video Ad',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: [150, 212, 201, 154, 190, 330, 410]
          },
          {
            name: 'Search Engine',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: [820, 832, 901, 934, 1290, 1330, 1320]
          }
        ]
      },
      opt3: {
        angleAxis: {},
        radiusAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu'],
          z: 10
        },
        polar: {},
        series: [
          {
            type: 'bar',
            data: [1, 2, 3, 4],
            coordinateSystem: 'polar',
            name: 'A',
            stack: 'a',
            emphasis: {
              focus: 'series'
            }
          },
          {
            type: 'bar',
            data: [2, 4, 6, 8],
            coordinateSystem: 'polar',
            name: 'B',
            stack: 'a',
            emphasis: {
              focus: 'series'
            }
          },
          {
            type: 'bar',
            data: [1, 2, 3, 4],
            coordinateSystem: 'polar',
            name: 'C',
            stack: 'a',
            emphasis: {
              focus: 'series'
            }
          }
        ],
        legend: {
          show: true,
          data: ['A', 'B', 'C']
        }
      },
      opt4: {
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%'
        },
        series: [
          {
            name: 'Pressure',
            type: 'gauge',
            detail: {
              formatter: '{value}'
            },
            data: [
              {
                value: 50,
                name: 'SCORE'
              }
            ]
          }
        ]
      }
    };
  },

  mounted() {

  },
  created() {
  },
  destroyed() {

  },
  methods: {
    page() {
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
        this.ruleForm.pageSize = setUp["pageSize"];
        this.ruleForm.too = setUp["too"];
      }
      this.dialogFormVisible = true;
    },
    openScreenForm() {
      this.screenFormVisible = true;
    }
  }
};
</script>
<style scoped>
#apg {
  background: #F4F5FA;
  height: 100vh;
}

* {
  font-family: '微软雅黑';
}
</style>
<style scoped src='./board.css'></style>
<style scoped src='./bootstrap.css'></style>


// WEBPACK FOOTER //
// src/pages/mickpi/board.vue